import React from 'react';

const ForColleges = (
  props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>,
) => {
  return (
    <svg
      width={44}
      height={62}
      viewBox='0 0 44 62'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M3.61328 22.996L6.65334 22.8359L6.6535 24.2269L3.61328 22.996Z'
        fill='#DE6B66'
      />
      <path
        d='M11.1053 18.3339L9.86103 20.2998C9.09611 21.5092 8.21356 21.541 7.43951 21.1061C7.34471 21.0521 7.25081 20.9916 7.15946 20.9255C6.59131 20.5137 6.05646 20.1318 5.55439 19.7755C0.552454 16.2238 -1.16061 15.2035 0.780055 12.7452C2.14542 11.0154 3.5891 11.1411 5.8965 12.4202C6.64175 12.8335 7.47782 13.3673 8.43054 13.998C9.13994 14.4678 9.91399 14.9916 10.7642 15.5592C11.9894 16.3772 11.8233 17.1981 11.1053 18.3339Z'
        fill='#FFA399'
      />
      <path
        d='M8.43035 13.9997L7.43932 21.1078C7.34453 21.0538 7.25062 20.9932 7.15927 20.9271C6.59112 20.5154 6.05627 20.1334 5.5542 19.7772C5.59253 17.6781 5.68644 14.0527 5.89632 12.4219C6.64157 12.8351 7.47763 13.369 8.43035 13.9997Z'
        fill='#F08276'
      />
      <path
        d='M43.3344 37.0278C39.4969 50.936 43.7368 58.686 43.7368 61.9936C35.2703 61.9936 21.5463 62.0007 16.3529 62.0007C14.7864 58.6222 14.3317 56.6139 13.5002 54.8891C12.9732 53.7987 12.2167 51.9594 11.6095 50.7058C11.4442 50.3777 11.1845 49.9178 11.0332 49.646C11.0322 49.6441 11.3981 49.4323 11.2044 49.1452C11.0755 48.9542 10.9159 48.796 10.7397 48.7964C9.90687 48.7983 8.70604 47.8884 8.70604 48.9237C8.16826 48.1575 7.68142 48.3804 7.22906 47.8967C4.46063 44.9266 8.99324 48.6629 6.78331 44.9456C6.52488 44.5113 6.83747 44.3097 6.49608 43.7812C6.52163 43.5939 6.57703 43.4006 6.66446 43.212L6.83102 42.8486L12.3973 42.6345C12.3973 42.6345 28.9071 48.5436 32.3295 39.1317C32.4195 38.8825 32.5051 38.6397 32.5879 38.4021C32.9255 37.4264 33.5291 25.8762 33.52 24.9501C33.5135 24.2264 33.5499 23.565 33.6213 22.9589C33.8182 21.309 34.2843 20.0763 34.8748 19.1709C36.5404 16.6119 39.6355 16.4925 39.6274 17.1765C39.5115 26.9221 44.5195 32.7348 43.3344 37.0278Z'
        fill='#FFA399'
      />
      <mask
        id='mask0_22334_31638'
        style={{ maskType: 'luminance' }}
        maskUnits='userSpaceOnUse'
        x={10}
        y={32}
        width={24}
        height={21}
      >
        <path
          d='M31.9126 49.6587C28.9889 51.4449 18.8741 50.6434 12.503 52.6849C12.0181 51.5993 12.2168 51.9721 11.6097 50.7185C11.2304 49.9342 10.9097 49.3793 10.7399 49.3799C10.7111 49.169 10.6953 49.3799 10.6953 49.1579H31.0015C31.8773 49.1579 32.588 48.4471 32.588 47.5713L32.588 38.4148C32.9256 37.4391 29.8034 35.8556 30.0209 35.0288C30.2114 34.3089 31.7998 33.6082 31.9125 32.9766C32.9322 37.8485 34.7966 47.8959 31.9126 49.6587Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask0_22334_31638)'>
        <path
          d='M32.0009 32.9766L32.1501 33.4547L10.6953 40.1529L10.6953 32.9766H32.0009Z'
          fill='#DE6B66'
        />
      </g>
      <mask
        id='mask1_22334_31638'
        style={{ maskType: 'luminance' }}
        maskUnits='userSpaceOnUse'
        x={10}
        y={32}
        width={24}
        height={21}
      >
        <path
          d='M31.9126 49.6587C28.9889 51.4449 18.8741 50.6434 12.503 52.6849C12.0181 51.5993 12.2168 51.9721 11.6097 50.7185C11.2304 49.9342 10.9097 49.3793 10.7399 49.3799C10.7111 49.169 10.6953 49.3799 10.6953 49.1579H31.0015C31.8773 49.1579 32.588 48.4471 32.588 47.5713L32.588 38.4148C32.9256 37.4391 29.8034 35.8556 30.0209 35.0288C30.2114 34.3089 31.7998 33.6082 31.9125 32.9766C32.9322 37.8485 34.7966 47.8959 31.9126 49.6587Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask1_22334_31638)'>
        <path
          d='M32.1501 33.4531L32.4042 34.2668L10.6953 41.0442L10.6953 40.1514L32.1501 33.4531Z'
          fill='#DE6B66'
        />
      </g>
      <mask
        id='mask2_22334_31638'
        style={{ maskType: 'luminance' }}
        maskUnits='userSpaceOnUse'
        x={10}
        y={32}
        width={24}
        height={21}
      >
        <path
          d='M31.9126 49.6587C28.9889 51.4449 18.8741 50.6434 12.503 52.6849C12.0181 51.5993 12.2168 51.9721 11.6097 50.7185C11.2304 49.9342 10.9097 49.3793 10.7399 49.3799C10.7111 49.169 10.6953 49.3799 10.6953 49.1579H31.0015C31.8773 49.1579 32.588 48.4471 32.588 47.5713L32.588 38.4148C32.9256 37.4391 29.8034 35.8556 30.0209 35.0288C30.2114 34.3089 31.7998 33.6082 31.9125 32.9766C32.9322 37.8485 34.7966 47.8959 31.9126 49.6587Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask2_22334_31638)'>
        <path
          d='M32.4042 34.2578L32.6581 35.0713L10.6953 41.928L10.6953 41.0352L32.4042 34.2578Z'
          fill='#DE6C67'
        />
      </g>
      <mask
        id='mask3_22334_31638'
        style={{ maskType: 'luminance' }}
        maskUnits='userSpaceOnUse'
        x={10}
        y={32}
        width={24}
        height={21}
      >
        <path
          d='M31.9126 49.6587C28.9889 51.4449 18.8741 50.6434 12.503 52.6849C12.0181 51.5993 12.2168 51.9721 11.6097 50.7185C11.2304 49.9342 10.9097 49.3793 10.7399 49.3799C10.7111 49.169 10.6953 49.3799 10.6953 49.1579H31.0015C31.8773 49.1579 32.588 48.4471 32.588 47.5713L32.588 38.4148C32.9256 37.4391 29.8034 35.8556 30.0209 35.0288C30.2114 34.3089 31.7998 33.6082 31.9125 32.9766C32.9322 37.8485 34.7966 47.8959 31.9126 49.6587Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask3_22334_31638)'>
        <path
          d='M32.6581 35.0703L32.9122 35.884L10.6953 42.82L10.6953 41.927L32.6581 35.0703Z'
          fill='#DF6D68'
        />
      </g>
      <mask
        id='mask4_22334_31638'
        style={{ maskType: 'luminance' }}
        maskUnits='userSpaceOnUse'
        x={10}
        y={32}
        width={24}
        height={21}
      >
        <path
          d='M31.9126 49.6587C28.9889 51.4449 18.8741 50.6434 12.503 52.6849C12.0181 51.5993 12.2168 51.9721 11.6097 50.7185C11.2304 49.9342 10.9097 49.3793 10.7399 49.3799C10.7111 49.169 10.6953 49.3799 10.6953 49.1579H31.0015C31.8773 49.1579 32.588 48.4471 32.588 47.5713L32.588 38.4148C32.9256 37.4391 29.8034 35.8556 30.0209 35.0288C30.2114 34.3089 31.7998 33.6082 31.9125 32.9766C32.9322 37.8485 34.7966 47.8959 31.9126 49.6587Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask4_22334_31638)'>
        <path
          d='M32.9122 35.8906L33.1661 36.7041L10.6953 43.7195L10.6953 42.8266L32.9122 35.8906Z'
          fill='#DF6E69'
        />
      </g>
      <mask
        id='mask5_22334_31638'
        style={{ maskType: 'luminance' }}
        maskUnits='userSpaceOnUse'
        x={10}
        y={32}
        width={24}
        height={21}
      >
        <path
          d='M31.9126 49.6587C28.9889 51.4449 18.8741 50.6434 12.503 52.6849C12.0181 51.5993 12.2168 51.9721 11.6097 50.7185C11.2304 49.9342 10.9097 49.3793 10.7399 49.3799C10.7111 49.169 10.6953 49.3799 10.6953 49.1579H31.0015C31.8773 49.1579 32.588 48.4471 32.588 47.5713L32.588 38.4148C32.9256 37.4391 29.8034 35.8556 30.0209 35.0288C30.2114 34.3089 31.7998 33.6082 31.9125 32.9766C32.9322 37.8485 34.7966 47.8959 31.9126 49.6587Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask5_22334_31638)'>
        <path
          d='M33.1661 36.7031L33.4201 37.5166L10.6953 44.6112L10.6953 43.7184L33.1661 36.7031Z'
          fill='#DF6F6A'
        />
      </g>
      <mask
        id='mask6_22334_31638'
        style={{ maskType: 'luminance' }}
        maskUnits='userSpaceOnUse'
        x={10}
        y={32}
        width={24}
        height={21}
      >
        <path
          d='M31.9126 49.6587C28.9889 51.4449 18.8741 50.6434 12.503 52.6849C12.0181 51.5993 12.2168 51.9721 11.6097 50.7185C11.2304 49.9342 10.9097 49.3793 10.7399 49.3799C10.7111 49.169 10.6953 49.3799 10.6953 49.1579H31.0015C31.8773 49.1579 32.588 48.4471 32.588 47.5713L32.588 38.4148C32.9256 37.4391 29.8034 35.8556 30.0209 35.0288C30.2114 34.3089 31.7998 33.6082 31.9125 32.9766C32.9322 37.8485 34.7966 47.8959 31.9126 49.6587Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask6_22334_31638)'>
        <path
          d='M33.4201 37.5234L33.6741 38.3371L10.6953 45.511L10.6953 44.618L33.4201 37.5234Z'
          fill='#DF706B'
        />
      </g>
      <mask
        id='mask7_22334_31638'
        style={{ maskType: 'luminance' }}
        maskUnits='userSpaceOnUse'
        x={10}
        y={32}
        width={24}
        height={21}
      >
        <path
          d='M31.9126 49.6587C28.9889 51.4449 18.8741 50.6434 12.503 52.6849C12.0181 51.5993 12.2168 51.9721 11.6097 50.7185C11.2304 49.9342 10.9097 49.3793 10.7399 49.3799C10.7111 49.169 10.6953 49.3799 10.6953 49.1579H31.0015C31.8773 49.1579 32.588 48.4471 32.588 47.5713L32.588 38.4148C32.9256 37.4391 29.8034 35.8556 30.0209 35.0288C30.2114 34.3089 31.7998 33.6082 31.9125 32.9766C32.9322 37.8485 34.7966 47.8959 31.9126 49.6587Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask7_22334_31638)'>
        <path
          d='M33.6741 38.3281L33.9282 39.1416L10.6953 46.3949L10.6953 45.5021L33.6741 38.3281Z'
          fill='#E0716C'
        />
      </g>
      <mask
        id='mask8_22334_31638'
        style={{ maskType: 'luminance' }}
        maskUnits='userSpaceOnUse'
        x={10}
        y={32}
        width={24}
        height={21}
      >
        <path
          d='M31.9126 49.6587C28.9889 51.4449 18.8741 50.6434 12.503 52.6849C12.0181 51.5993 12.2168 51.9721 11.6097 50.7185C11.2304 49.9342 10.9097 49.3793 10.7399 49.3799C10.7111 49.169 10.6953 49.3799 10.6953 49.1579H31.0015C31.8773 49.1579 32.588 48.4471 32.588 47.5713L32.588 38.4148C32.9256 37.4391 29.8034 35.8556 30.0209 35.0288C30.2114 34.3089 31.7998 33.6082 31.9125 32.9766C32.9322 37.8485 34.7966 47.8959 31.9126 49.6587Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask8_22334_31638)'>
        <path
          d='M33.9282 39.1484L34.1821 39.9621L10.6953 47.2945L10.6953 46.4017L33.9282 39.1484Z'
          fill='#E0726D'
        />
      </g>
      <mask
        id='mask9_22334_31638'
        style={{ maskType: 'luminance' }}
        maskUnits='userSpaceOnUse'
        x={10}
        y={32}
        width={24}
        height={21}
      >
        <path
          d='M31.9126 49.6587C28.9889 51.4449 18.8741 50.6434 12.503 52.6849C12.0181 51.5993 12.2168 51.9721 11.6097 50.7185C11.2304 49.9342 10.9097 49.3793 10.7399 49.3799C10.7111 49.169 10.6953 49.3799 10.6953 49.1579H31.0015C31.8773 49.1579 32.588 48.4471 32.588 47.5713L32.588 38.4148C32.9256 37.4391 29.8034 35.8556 30.0209 35.0288C30.2114 34.3089 31.7998 33.6082 31.9125 32.9766C32.9322 37.8485 34.7966 47.8959 31.9126 49.6587Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask9_22334_31638)'>
        <path
          d='M34.1821 39.9609L34.4361 40.7745L10.6953 48.1863L10.6953 47.2933L34.1821 39.9609Z'
          fill='#E0736E'
        />
      </g>
      <mask
        id='mask10_22334_31638'
        style={{ maskType: 'luminance' }}
        maskUnits='userSpaceOnUse'
        x={10}
        y={32}
        width={24}
        height={21}
      >
        <path
          d='M31.9126 49.6587C28.9889 51.4449 18.8741 50.6434 12.503 52.6849C12.0181 51.5993 12.2168 51.9721 11.6097 50.7185C11.2304 49.9342 10.9097 49.3793 10.7399 49.3799C10.7111 49.169 10.6953 49.3799 10.6953 49.1579H31.0015C31.8773 49.1579 32.588 48.4471 32.588 47.5713L32.588 38.4148C32.9256 37.4391 29.8034 35.8556 30.0209 35.0288C30.2114 34.3089 31.7998 33.6082 31.9125 32.9766C32.9322 37.8485 34.7966 47.8959 31.9126 49.6587Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask10_22334_31638)'>
        <path
          d='M34.4361 40.7734L34.69 41.5869L10.6953 49.0781L10.6953 48.1853L34.4361 40.7734Z'
          fill='#E0746F'
        />
      </g>
      <mask
        id='mask11_22334_31638'
        style={{ maskType: 'luminance' }}
        maskUnits='userSpaceOnUse'
        x={10}
        y={32}
        width={24}
        height={21}
      >
        <path
          d='M31.9126 49.6587C28.9889 51.4449 18.8741 50.6434 12.503 52.6849C12.0181 51.5993 12.2168 51.9721 11.6097 50.7185C11.2304 49.9342 10.9097 49.3793 10.7399 49.3799C10.7111 49.169 10.6953 49.3799 10.6953 49.1579H31.0015C31.8773 49.1579 32.588 48.4471 32.588 47.5713L32.588 38.4148C32.9256 37.4391 29.8034 35.8556 30.0209 35.0288C30.2114 34.3089 31.7998 33.6082 31.9125 32.9766C32.9322 37.8485 34.7966 47.8959 31.9126 49.6587Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask11_22334_31638)'>
        <path
          d='M34.69 41.5859L34.7965 41.9269L34.7965 42.4456L10.7837 49.9422L10.6953 49.6588L10.6953 49.0771L34.69 41.5859Z'
          fill='#E17571'
        />
      </g>
      <mask
        id='mask12_22334_31638'
        style={{ maskType: 'luminance' }}
        maskUnits='userSpaceOnUse'
        x={10}
        y={32}
        width={24}
        height={21}
      >
        <path
          d='M31.9126 49.6587C28.9889 51.4449 18.8741 50.6434 12.503 52.6849C12.0181 51.5993 12.2168 51.9721 11.6097 50.7185C11.2304 49.9342 10.9097 49.3793 10.7399 49.3799C10.7111 49.169 10.6953 49.3799 10.6953 49.1579H31.0015C31.8773 49.1579 32.588 48.4471 32.588 47.5713L32.588 38.4148C32.9256 37.4391 29.8034 35.8556 30.0209 35.0288C30.2114 34.3089 31.7998 33.6082 31.9125 32.9766C32.9322 37.8485 34.7966 47.8959 31.9126 49.6587Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask12_22334_31638)'>
        <path
          d='M34.7965 43.3381L11.0378 50.7556L10.7837 49.9419L34.7965 42.4453L34.7965 43.3381Z'
          fill='#E17572'
        />
      </g>
      <mask
        id='mask13_22334_31638'
        style={{ maskType: 'luminance' }}
        maskUnits='userSpaceOnUse'
        x={10}
        y={32}
        width={24}
        height={21}
      >
        <path
          d='M31.9126 49.6587C28.9889 51.4449 18.8741 50.6434 12.503 52.6849C12.0181 51.5993 12.2168 51.9721 11.6097 50.7185C11.2304 49.9342 10.9097 49.3793 10.7399 49.3799C10.7111 49.169 10.6953 49.3799 10.6953 49.1579H31.0015C31.8773 49.1579 32.588 48.4471 32.588 47.5713L32.588 38.4148C32.9256 37.4391 29.8034 35.8556 30.0209 35.0288C30.2114 34.3089 31.7998 33.6082 31.9125 32.9766C32.9322 37.8485 34.7966 47.8959 31.9126 49.6587Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask13_22334_31638)'>
        <path
          d='M34.7969 44.2366L11.292 51.5747L11.0381 50.7612L34.7969 43.3438L34.7969 44.2366Z'
          fill='#E17673'
        />
      </g>
      <mask
        id='mask14_22334_31638'
        style={{ maskType: 'luminance' }}
        maskUnits='userSpaceOnUse'
        x={10}
        y={32}
        width={24}
        height={21}
      >
        <path
          d='M31.9126 49.6587C28.9889 51.4449 18.8741 50.6434 12.503 52.6849C12.0181 51.5993 12.2168 51.9721 11.6097 50.7185C11.2304 49.9342 10.9097 49.3793 10.7399 49.3799C10.7111 49.169 10.6953 49.3799 10.6953 49.1579H31.0015C31.8773 49.1579 32.588 48.4471 32.588 47.5713L32.588 38.4148C32.9256 37.4391 29.8034 35.8556 30.0209 35.0288C30.2114 34.3089 31.7998 33.6082 31.9125 32.9766C32.9322 37.8485 34.7966 47.8959 31.9126 49.6587Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask14_22334_31638)'>
        <path
          d='M34.7964 45.1273L11.5456 52.3862L11.2915 51.5725L34.7964 44.2344L34.7964 45.1273Z'
          fill='#E17774'
        />
      </g>
      <mask
        id='mask15_22334_31638'
        style={{ maskType: 'luminance' }}
        maskUnits='userSpaceOnUse'
        x={10}
        y={32}
        width={24}
        height={21}
      >
        <path
          d='M31.9126 49.6587C28.9889 51.4449 18.8741 50.6434 12.503 52.6849C12.0181 51.5993 12.2168 51.9721 11.6097 50.7185C11.2304 49.9342 10.9097 49.3793 10.7399 49.3799C10.7111 49.169 10.6953 49.3799 10.6953 49.1579H31.0015C31.8773 49.1579 32.588 48.4471 32.588 47.5713L32.588 38.4148C32.9256 37.4391 29.8034 35.8556 30.0209 35.0288C30.2114 34.3089 31.7998 33.6082 31.9125 32.9766C32.9322 37.8485 34.7966 47.8959 31.9126 49.6587Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask15_22334_31638)'>
        <path
          d='M34.7967 46.0178L13.4529 52.6813H11.6387L11.5459 52.3838L34.7967 45.125L34.7967 46.0178Z'
          fill='#E27875'
        />
      </g>
      <mask
        id='mask16_22334_31638'
        style={{ maskType: 'luminance' }}
        maskUnits='userSpaceOnUse'
        x={10}
        y={32}
        width={24}
        height={21}
      >
        <path
          d='M31.9126 49.6587C28.9889 51.4449 18.8741 50.6434 12.503 52.6849C12.0181 51.5993 12.2168 51.9721 11.6097 50.7185C11.2304 49.9342 10.9097 49.3793 10.7399 49.3799C10.7111 49.169 10.6953 49.3799 10.6953 49.1579H31.0015C31.8773 49.1579 32.588 48.4471 32.588 47.5713L32.588 38.4148C32.9256 37.4391 29.8034 35.8556 30.0209 35.0288C30.2114 34.3089 31.7998 33.6082 31.9125 32.9766C32.9322 37.8485 34.7966 47.8959 31.9126 49.6587Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask16_22334_31638)'>
        <path
          d='M34.7965 46.9085L16.3126 52.6791H13.4526L34.7965 46.0156L34.7965 46.9085Z'
          fill='#E27976'
        />
      </g>
      <mask
        id='mask17_22334_31638'
        style={{ maskType: 'luminance' }}
        maskUnits='userSpaceOnUse'
        x={10}
        y={32}
        width={24}
        height={21}
      >
        <path
          d='M31.9126 49.6587C28.9889 51.4449 18.8741 50.6434 12.503 52.6849C12.0181 51.5993 12.2168 51.9721 11.6097 50.7185C11.2304 49.9342 10.9097 49.3793 10.7399 49.3799C10.7111 49.169 10.6953 49.3799 10.6953 49.1579H31.0015C31.8773 49.1579 32.588 48.4471 32.588 47.5713L32.588 38.4148C32.9256 37.4391 29.8034 35.8556 30.0209 35.0288C30.2114 34.3089 31.7998 33.6082 31.9125 32.9766C32.9322 37.8485 34.7966 47.8959 31.9126 49.6587Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask17_22334_31638)'>
        <path
          d='M34.7969 47.7992L19.1729 52.6769H16.313L34.7969 46.9062L34.7969 47.7992Z'
          fill='#E27A77'
        />
      </g>
      <mask
        id='mask18_22334_31638'
        style={{ maskType: 'luminance' }}
        maskUnits='userSpaceOnUse'
        x={10}
        y={32}
        width={24}
        height={21}
      >
        <path
          d='M31.9126 49.6587C28.9889 51.4449 18.8741 50.6434 12.503 52.6849C12.0181 51.5993 12.2168 51.9721 11.6097 50.7185C11.2304 49.9342 10.9097 49.3793 10.7399 49.3799C10.7111 49.169 10.6953 49.3799 10.6953 49.1579H31.0015C31.8773 49.1579 32.588 48.4471 32.588 47.5713L32.588 38.4148C32.9256 37.4391 29.8034 35.8556 30.0209 35.0288C30.2114 34.3089 31.7998 33.6082 31.9125 32.9766C32.9322 37.8485 34.7966 47.8959 31.9126 49.6587Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask18_22334_31638)'>
        <path
          d='M34.7973 48.6897L22.0333 52.6746H19.1733L34.7973 47.7969L34.7973 48.6897Z'
          fill='#E27B78'
        />
      </g>
      <mask
        id='mask19_22334_31638'
        style={{ maskType: 'luminance' }}
        maskUnits='userSpaceOnUse'
        x={10}
        y={32}
        width={24}
        height={21}
      >
        <path
          d='M31.9126 49.6587C28.9889 51.4449 18.8741 50.6434 12.503 52.6849C12.0181 51.5993 12.2168 51.9721 11.6097 50.7185C11.2304 49.9342 10.9097 49.3793 10.7399 49.3799C10.7111 49.169 10.6953 49.3799 10.6953 49.1579H31.0015C31.8773 49.1579 32.588 48.4471 32.588 47.5713L32.588 38.4148C32.9256 37.4391 29.8034 35.8556 30.0209 35.0288C30.2114 34.3089 31.7998 33.6082 31.9125 32.9766C32.9322 37.8485 34.7966 47.8959 31.9126 49.6587Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask19_22334_31638)'>
        <path
          d='M34.7967 49.5803L24.8926 52.6724H22.0327L34.7967 48.6875L34.7967 49.5803Z'
          fill='#E37C79'
        />
      </g>
      <mask
        id='mask20_22334_31638'
        style={{ maskType: 'luminance' }}
        maskUnits='userSpaceOnUse'
        x={10}
        y={32}
        width={24}
        height={21}
      >
        <path
          d='M31.9126 49.6587C28.9889 51.4449 18.8741 50.6434 12.503 52.6849C12.0181 51.5993 12.2168 51.9721 11.6097 50.7185C11.2304 49.9342 10.9097 49.3793 10.7399 49.3799C10.7111 49.169 10.6953 49.3799 10.6953 49.1579H31.0015C31.8773 49.1579 32.588 48.4471 32.588 47.5713L32.588 38.4148C32.9256 37.4391 29.8034 35.8556 30.0209 35.0288C30.2114 34.3089 31.7998 33.6082 31.9125 32.9766C32.9322 37.8485 34.7966 47.8959 31.9126 49.6587Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask20_22334_31638)'>
        <path
          d='M34.7967 50.4867L27.7525 52.6859H24.8926L34.7967 49.5938L34.7967 50.4867Z'
          fill='#E37D7A'
        />
      </g>
      <mask
        id='mask21_22334_31638'
        style={{ maskType: 'luminance' }}
        maskUnits='userSpaceOnUse'
        x={10}
        y={32}
        width={24}
        height={21}
      >
        <path
          d='M31.9126 49.6587C28.9889 51.4449 18.8741 50.6434 12.503 52.6849C12.0181 51.5993 12.2168 51.9721 11.6097 50.7185C11.2304 49.9342 10.9097 49.3793 10.7399 49.3799C10.7111 49.169 10.6953 49.3799 10.6953 49.1579H31.0015C31.8773 49.1579 32.588 48.4471 32.588 47.5713L32.588 38.4148C32.9256 37.4391 29.8034 35.8556 30.0209 35.0288C30.2114 34.3089 31.7998 33.6082 31.9125 32.9766C32.9322 37.8485 34.7966 47.8959 31.9126 49.6587Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask21_22334_31638)'>
        <path
          d='M34.7961 51.3772L30.6118 52.6835H27.752L34.7961 50.4844L34.7961 51.3772Z'
          fill='#E37E7B'
        />
      </g>
      <mask
        id='mask22_22334_31638'
        style={{ maskType: 'luminance' }}
        maskUnits='userSpaceOnUse'
        x={10}
        y={32}
        width={24}
        height={21}
      >
        <path
          d='M31.9126 49.6587C28.9889 51.4449 18.8741 50.6434 12.503 52.6849C12.0181 51.5993 12.2168 51.9721 11.6097 50.7185C11.2304 49.9342 10.9097 49.3793 10.7399 49.3799C10.7111 49.169 10.6953 49.3799 10.6953 49.1579H31.0015C31.8773 49.1579 32.588 48.4471 32.588 47.5713L32.588 38.4148C32.9256 37.4391 29.8034 35.8556 30.0209 35.0288C30.2114 34.3089 31.7998 33.6082 31.9125 32.9766C32.9322 37.8485 34.7966 47.8959 31.9126 49.6587Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask22_22334_31638)'>
        <path
          d='M30.6123 52.6892L34.7967 51.3828L34.7967 52.6892H30.6123Z'
          fill='#E37E7B'
        />
      </g>
      <path
        d='M33.5201 3.3294L33.5201 46.3234C33.5201 46.7276 33.4599 47.117 33.35 47.4757C32.9628 48.7431 31.9576 49.6524 30.7849 49.6524H9.23357C8.86127 49.6524 8.5058 49.5608 8.18107 49.3948C7.81308 49.2066 7.48513 48.9231 7.21882 48.5698C6.98108 48.2544 6.79203 47.8841 6.66728 47.4757C6.5572 47.117 6.49695 46.7276 6.49695 46.3234L6.49695 3.3294C6.49695 2.92435 6.5572 2.53633 6.66728 2.17701C7.05477 0.909617 8.06095 0 9.23357 0L30.7849 0C31.3748 0 31.9228 0.230256 32.3709 0.621032C32.7658 0.965102 33.0835 1.43442 33.2833 1.97962C33.3074 2.04442 33.3296 2.11007 33.35 2.17701C33.4599 2.53636 33.5201 2.92435 33.5201 3.3294Z'
        fill='#17152D'
      />
      <path
        d='M32.3112 3.13259L32.3112 46.4982C32.3112 47.4499 31.6752 48.2246 30.8918 48.2246H9.12329C8.5336 48.2246 8.02668 47.7847 7.81314 47.1609C7.80214 47.13 7.79247 47.0984 7.7832 47.0667L7.7832 3.17731C7.7832 2.51169 8.07905 1.92246 8.53111 1.56328C8.53238 1.56328 8.53238 1.56328 8.53238 1.56284C8.71178 1.46195 8.91224 1.40625 9.12329 1.40625H30.8918C31.6752 1.40625 32.3112 2.18079 32.3112 3.13259Z'
        fill='#6E311C'
      />
      <path
        d='M39.3161 24.2207C39.1017 24.2207 38.9142 24.1578 38.7569 24.0327C38.1528 23.5523 38.0844 22.2424 38.0052 20.7257C37.9969 20.5666 37.9885 20.4058 37.9794 20.2441C37.9317 19.4023 38.0929 18.7731 38.4583 18.3741C38.8131 17.9867 39.2296 17.9693 39.2471 17.9688C39.3172 17.9669 39.3754 18.0215 39.3776 18.0914C39.3798 18.1613 39.325 18.2197 39.255 18.2219C39.2422 18.2225 38.9211 18.2399 38.6404 18.5503C38.3261 18.8977 38.1888 19.4628 38.2322 20.2298C38.2414 20.3918 38.2499 20.5531 38.2582 20.7125C38.331 22.1075 38.3998 23.4251 38.9145 23.8345C39.0659 23.9548 39.2539 23.993 39.4894 23.9514C39.5581 23.9393 39.624 23.9852 39.6362 24.0541C39.6484 24.123 39.6024 24.1887 39.5336 24.2008C39.4583 24.214 39.3858 24.2207 39.3161 24.2207Z'
        fill='#DE6B66'
      />
      <path
        d='M31.9131 11.1328H8.21045L8.21045 12.9888H31.9131L31.9131 11.1328Z'
        fill='#B3512D'
      />
      <path
        d='M31.9128 21.6953H7.78857L7.78857 24.134H31.9128L31.9128 21.6953Z'
        fill='#B3512D'
      />
      <path
        d='M32.3112 45.8828L32.3112 46.5092C32.3112 47.4609 31.6752 48.2355 30.8918 48.2355H9.12329C8.5336 48.2355 8.02668 47.7957 7.81314 47.1718C7.80214 47.141 7.79247 47.1093 7.7832 47.0777L7.7832 45.8828H32.3112Z'
        fill='#B3512D'
      />
      <mask
        id='mask23_22334_31638'
        style={{ maskType: 'luminance' }}
        maskUnits='userSpaceOnUse'
        x={7}
        y={1}
        width={26}
        height={48}
      >
        <path
          d='M32.3054 3.4207L32.3054 46.7662C32.3054 47.7176 31.6696 48.4915 30.8865 48.4915H9.1283C8.53875 48.4915 8.0321 48.0521 7.81886 47.4285C7.80792 47.3976 7.79795 47.3661 7.78882 47.3344L7.78882 3.46562C7.78882 2.80021 8.08445 2.21115 8.53661 1.85228C8.53743 1.85228 8.53743 1.85228 8.53743 1.85185C8.7171 1.75112 8.91723 1.69531 9.1283 1.69531H30.8865C31.6696 1.69531 32.3054 2.46931 32.3054 3.4207Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask23_22334_31638)'>
        <path
          d='M11.4494 4.39844H7.68628L7.68628 21.8565H11.4494L11.4494 4.39844Z'
          fill='#DF5632'
        />
        <path
          d='M15.2121 5.44531H11.449L11.449 21.8559H15.2121L15.2121 5.44531Z'
          fill='#1F596D'
        />
        <path
          d='M17.8117 4.39844H15.2122L15.2122 21.8565H17.8117L17.8117 4.39844Z'
          fill='#7FADAA'
        />
        <path
          d='M21.8773 6.72656H17.8118L17.8118 21.8569H21.8773L21.8773 6.72656Z'
          fill='#F6951F'
        />
        <path
          d='M25.9423 6.72656H21.8767L21.8767 21.8569H25.9423L25.9423 6.72656Z'
          fill='#F6951F'
        />
        <path
          d='M30.0082 6.72656H25.9426L25.9426 21.8569H30.0082L30.0082 6.72656Z'
          fill='#F6951F'
        />
        <path
          d='M11.1273 19.125H7.68628L7.68628 19.7069H11.1273L11.1273 19.125Z'
          fill='#944325'
        />
        <path
          d='M11.1273 6.42969H7.68628L7.68628 7.01163H11.1273L11.1273 6.42969Z'
          fill='#944325'
        />
        <path
          d='M10.9877 9.15625H8.14673L8.14673 13.1208H10.9877L10.9877 9.15625Z'
          fill='#944325'
        />
        <path
          d='M14.4281 8.85156H12.2332L12.2332 15.6282H14.4281L14.4281 8.85156Z'
          fill='#249BD0'
        />
        <path
          d='M14.8154 17.6875H11.4485L11.4485 18.1531H14.8154L14.8154 17.6875Z'
          fill='#249BD0'
        />
        <path
          d='M17.5574 6.10156H15.2117L15.2117 6.56717H17.5574L17.5574 6.10156Z'
          fill='#36736F'
        />
        <path
          d='M17.5574 7.57812H15.2117L15.2117 8.0437H17.5574L17.5574 7.57812Z'
          fill='#36736F'
        />
        <path
          d='M17.5574 19.7891H15.2117L15.2117 20.2546H17.5574L17.5574 19.7891Z'
          fill='#36736F'
        />
        <path
          d='M17.3768 12.0453C17.3768 13.6452 16.9896 14.9422 16.5121 14.9422C16.0344 14.9422 15.6472 13.6452 15.6472 12.0453C15.6472 10.4454 16.0344 9.14844 16.5121 9.14844C16.9897 9.14844 17.3768 10.4454 17.3768 12.0453Z'
          fill='#36736F'
        />
        <path
          d='M19.2777 12.69H19.2722L18.9565 12.8604L18.9089 12.6733L19.3057 12.4609H19.5152L19.5152 14.2768H19.2777L19.2777 12.69Z'
          fill='#D94B1B'
        />
        <path
          d='M23.0886 14.2997L23.0886 14.1488L23.2814 13.9617C23.7452 13.5203 23.9547 13.2856 23.9575 13.0118C23.9575 12.8274 23.868 12.657 23.5971 12.657C23.4322 12.657 23.2954 12.7408 23.2115 12.8107L23.1334 12.6375C23.2591 12.5313 23.4379 12.4531 23.6474 12.4531C24.0385 12.4531 24.2033 12.7213 24.2033 12.9811C24.2033 13.3164 23.9603 13.5874 23.5776 13.9561L23.4322 14.0902L23.4322 14.0958H24.248L24.248 14.2997H23.0886V14.2997Z'
          fill='#D94B1B'
        />
        <path
          d='M27.4755 14.002C27.5453 14.0467 27.7073 14.1165 27.8778 14.1165C28.1934 14.1165 28.2912 13.9153 28.2885 13.7645C28.2856 13.5103 28.0566 13.4013 27.8191 13.4013H27.6822L27.6822 13.2169H27.8191C27.9979 13.2169 28.2242 13.1247 28.2242 12.9096C28.2242 12.7644 28.132 12.6358 27.9057 12.6358C27.7604 12.6358 27.6207 12.7001 27.5425 12.756L27.4783 12.5772C27.5732 12.5073 27.7577 12.4375 27.9532 12.4375C28.3108 12.4375 28.4729 12.6498 28.4729 12.8705C28.4729 13.0577 28.3611 13.2169 28.1376 13.2979L28.1376 13.3036C28.3611 13.3483 28.5427 13.5159 28.5427 13.7701C28.5427 14.0606 28.3164 14.3148 27.8806 14.3148C27.6767 14.3148 27.4978 14.2506 27.4084 14.192L27.4755 14.002Z'
          fill='#D94B1B'
        />
        <path
          d='M21.8767 6.72656H21.4758L21.4758 8.23578H21.8767L21.8767 6.72656Z'
          fill='#DE701C'
        />
        <path
          d='M21.8767 9.15625H21.4758L21.4758 18.4933H21.8767L21.8767 9.15625Z'
          fill='#DE701C'
        />
        <path
          d='M21.8767 19.3984H21.4758L21.4758 21.8458H21.8767L21.8767 19.3984Z'
          fill='#DE701C'
        />
        <path
          d='M25.9417 6.72656H25.5408L25.5408 21.8569H25.9417L25.9417 6.72656Z'
          fill='#DE701C'
        />
        <path
          d='M30.0081 6.72656H29.6072L29.6072 21.8569H30.0081L30.0081 6.72656Z'
          fill='#DE701C'
        />
        <path
          d='M21.4765 8.22656H17.8118L17.8118 9.1449H21.4765L21.4765 8.22656Z'
          fill='#D94B1B'
        />
        <path
          d='M21.8767 8.22656H21.4758L21.4758 9.1449H21.8767L21.8767 8.22656Z'
          fill='#CC3E1A'
        />
        <path
          d='M21.8767 18.4844H21.4758L21.4758 19.4027H21.8767L21.8767 18.4844Z'
          fill='#CC3E1A'
        />
        <path
          d='M21.4765 18.4844H17.8118L17.8118 19.4027H21.4765L21.4765 18.4844Z'
          fill='#D94B1B'
        />
        <path
          d='M25.9423 8.22656H21.8767L21.8767 9.14479H25.9423L25.9423 8.22656Z'
          fill='#D94B1B'
        />
        <path
          d='M25.9423 18.4844H21.8767L21.8767 19.4026H25.9423L25.9423 18.4844Z'
          fill='#D94B1B'
        />
        <path
          d='M30.0082 8.22656H25.9426L25.9426 9.14479H30.0082L30.0082 8.22656Z'
          fill='#D94B1B'
        />
        <path
          d='M30.0082 18.4844H25.9426L25.9426 19.4026H30.0082L30.0082 18.4844Z'
          fill='#D94B1B'
        />
        <path
          d='M25.943 8.22656H25.5422L25.5422 9.1449H25.943L25.943 8.22656Z'
          fill='#CC3E1A'
        />
        <path
          d='M25.943 18.4844H25.5422L25.5422 19.4027H25.943L25.943 18.4844Z'
          fill='#CC3E1A'
        />
        <path
          d='M30.0085 8.22656H29.6077L29.6077 9.1449H30.0085L30.0085 8.22656Z'
          fill='#CC3E1A'
        />
        <path
          d='M30.0085 18.4844H29.6077L29.6077 19.4027H30.0085L30.0085 18.4844Z'
          fill='#CC3E1A'
        />
        <path
          d='M17.8111 6.10156H17.5574L17.5574 6.56717H17.8111L17.8111 6.10156Z'
          fill='#306662'
        />
        <path
          d='M17.8111 4.39844H17.5574L17.5574 6.11448H17.8111L17.8111 4.39844Z'
          fill='#5C7D7B'
        />
        <path
          d='M17.8111 7.57812H17.5574L17.5574 8.0437H17.8111L17.8111 7.57812Z'
          fill='#306662'
        />
        <path
          d='M17.8111 6.5625H17.5574L17.5574 7.57122H17.8111L17.8111 6.5625Z'
          fill='#5C7D7B'
        />
        <path
          d='M17.8111 19.7891H17.5574L17.5574 20.2546H17.8111L17.8111 19.7891Z'
          fill='#306662'
        />
        <path
          d='M17.8111 8.04688H17.5574L17.5574 19.7899H17.8111L17.8111 8.04688Z'
          fill='#5C7D7B'
        />
        <path
          d='M17.8111 20.2578H17.5574L17.5574 21.8516H17.8111L17.8111 20.2578Z'
          fill='#5C7D7B'
        />
        <path
          d='M15.2118 17.6875H14.8157L14.8157 18.1531H15.2118L15.2118 17.6875Z'
          fill='#1A6E94'
        />
        <path
          d='M15.2118 5.44531H14.8157L14.8157 17.7015H15.2118L15.2118 5.44531Z'
          fill='#0E3B4A'
        />
        <path
          d='M15.2118 18.1641H14.8157L14.8157 21.853H15.2118L15.2118 18.1641Z'
          fill='#0E3B4A'
        />
        <path
          d='M11.4482 6.42969H11.1262L11.1262 7.01163H11.4482L11.4482 6.42969Z'
          fill='#70331C'
        />
        <path
          d='M11.4482 4.39844H11.1262L11.1262 6.43536H11.4482L11.4482 4.39844Z'
          fill='#BD3A17'
        />
        <path
          d='M11.4482 19.125H11.1262L11.1262 19.7069H11.4482L11.4482 19.125Z'
          fill='#70331C'
        />
        <path
          d='M11.4485 7.02344H11.1265L11.1265 19.1245H11.4485L11.4485 7.02344Z'
          fill='#BD3A17'
        />
        <path
          d='M11.4482 19.6953H11.1262L11.1262 21.8517H11.4482L11.4482 19.6953Z'
          fill='#BD3A17'
        />
        <path
          d='M32.3288 4.39844H30.0081L30.0081 21.8563H32.3288L32.3288 4.39844Z'
          fill='#4F781F'
        />
        <path
          d='M32.3288 4.39844H31.928L31.928 5.34506H32.3288L32.3288 4.39844Z'
          fill='#3C5C18'
        />
        <path
          d='M32.3283 6.36719H31.9275L31.9275 15.4412H32.3283L32.3283 6.36719Z'
          fill='#3C5C18'
        />
        <path
          d='M32.3283 16.5781H31.9275L31.9275 17.831H32.3283L32.3283 16.5781Z'
          fill='#3C5C18'
        />
        <path
          d='M32.3283 18.9375H31.9275L31.9275 21.8438H32.3283L32.3283 18.9375Z'
          fill='#3C5C18'
        />
        <path
          d='M32.3283 5.33594H31.9275L31.9275 6.36395H32.3283L32.3283 5.33594Z'
          fill='#568522'
        />
        <path
          d='M31.9283 5.33594H30.0085L30.0085 6.36395H31.9283L31.9283 5.33594Z'
          fill='#6CA62A'
        />
        <path
          d='M32.3283 15.4453H31.9275L31.9275 16.5704H32.3283L32.3283 15.4453Z'
          fill='#568522'
        />
        <path
          d='M31.9278 15.4453H30.0081L30.0081 16.5704H31.9278L31.9278 15.4453Z'
          fill='#6CA62A'
        />
        <path
          d='M32.3283 17.8203H31.9275L31.9275 18.9454H32.3283L32.3283 17.8203Z'
          fill='#568522'
        />
        <path
          d='M31.9278 17.8203H30.0081L30.0081 18.9454H31.9278L31.9278 17.8203Z'
          fill='#6CA62A'
        />
      </g>
      <mask
        id='mask24_22334_31638'
        style={{ maskType: 'luminance' }}
        maskUnits='userSpaceOnUse'
        x={7}
        y={1}
        width={26}
        height={48}
      >
        <path
          d='M32.3054 3.4207L32.3054 46.7662C32.3054 47.7176 31.6696 48.4915 30.8865 48.4915H9.1283C8.53875 48.4915 8.0321 48.0521 7.81886 47.4285C7.80792 47.3976 7.79795 47.3661 7.78882 47.3344L7.78882 3.46562C7.78882 2.80021 8.08445 2.21115 8.53661 1.85228C8.53743 1.85228 8.53743 1.85228 8.53743 1.85185C8.7171 1.75112 8.91723 1.69531 9.1283 1.69531H30.8865C31.6696 1.69531 32.3054 2.46931 32.3054 3.4207Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask24_22334_31638)'>
        <path
          d='M10.6954 25.9297H7.78882L7.78882 45.8093H10.6954L10.6954 25.9297Z'
          fill='#345693'
        />
        <path
          d='M22.5049 29.7812H20.5339L20.5339 45.8348H22.5049L22.5049 29.7812Z'
          fill='#FF8D52'
        />
        <path
          d='M24.4756 29.7812H22.5046L22.5046 45.8348H24.4756L24.4756 29.7812Z'
          fill='#7DBBCA'
        />
        <path
          d='M27.143 25.9297H24.4763L24.4763 45.8093H27.143L27.143 25.9297Z'
          fill='#2BB673'
        />
        <path
          d='M14.2343 27.1875H10.6956L10.6956 45.8238H14.2343L14.2343 27.1875Z'
          fill='#067181'
        />
        <path
          d='M16.393 28.3828H14.2341L14.2341 45.8277H16.393L16.393 28.3828Z'
          fill='#269BCE'
        />
        <path
          d='M20.5336 27.1875H16.3928L16.3928 45.8237H20.5336L20.5336 27.1875Z'
          fill='#FFBF17'
        />
        <path
          d='M10.3309 25.9297H7.78882L7.78882 30.3023H10.3309L10.3309 25.9297Z'
          fill='#559CC8'
        />
        <path
          d='M10.3309 31.4688H7.78882L7.78882 33.1865H10.3309L10.3309 31.4688Z'
          fill='#559CC8'
        />
        <path
          d='M10.3309 43.3516H7.78882L7.78882 44.2102H10.3309L10.3309 43.3516Z'
          fill='#559CC8'
        />
        <path
          d='M13.6105 35.8854C13.6105 38.2729 13.0976 40.2084 12.4648 40.2084C11.8321 40.2084 11.3191 38.2729 11.3191 35.8854C11.3191 33.4979 11.8321 31.5625 12.4648 31.5625C13.0976 31.5625 13.6105 33.4979 13.6105 35.8854Z'
          fill='#089FB5'
        />
        <path
          d='M13.9228 41.9844H10.6956L10.6956 42.9285H13.9228L13.9228 41.9844Z'
          fill='#089FB5'
        />
        <path
          d='M13.9228 28.8516H10.6956L10.6956 29.7709H13.9228L13.9228 28.8516Z'
          fill='#089FB5'
        />
        <path
          d='M16.014 30.4062H14.2336L14.2336 35.9466H16.014L16.014 30.4062Z'
          fill='#0D598F'
        />
        <path
          d='M16.014 43.7891H14.2336L14.2336 44.3889H16.014L16.014 43.7891Z'
          fill='#0D598F'
        />
        <path
          d='M16.0145 42.1562H14.2341L14.2341 42.756H16.0145L16.0145 42.1562Z'
          fill='#0D598F'
        />
        <path
          d='M20.0203 31.7344H16.9065L16.9065 36.5065H20.0203L20.0203 31.7344Z'
          fill='#DF5632'
        />
        <path
          d='M20.2353 40.9297H16.3928L16.3928 41.5588H20.2353L20.2353 40.9297Z'
          fill='#DF5632'
        />
        <path
          d='M20.2353 29.3125H16.3928L16.3928 29.9421H20.2353L20.2353 29.3125Z'
          fill='#DF5632'
        />
        <path
          d='M22.0574 30.8984H20.5334L20.5334 31.3168H22.0574L22.0574 30.8984Z'
          fill='#DF5632'
        />
        <path
          d='M22.0572 32.6953H20.5332L20.5332 36.9685H22.0572L22.0572 32.6953Z'
          fill='#DF5632'
        />
        <path
          d='M22.0574 43.7891H20.5334L20.5334 44.2185H22.0574L22.0574 43.7891Z'
          fill='#DF5632'
        />
        <path
          d='M22.0574 42.25H20.5334L20.5334 42.6793H22.0574L22.0574 42.25Z'
          fill='#DF5632'
        />
        <path
          d='M24.4758 31.5625H22.5046L22.5046 31.8855H24.4758L24.4758 31.5625Z'
          fill='#B3DAE3'
        />
        <path
          d='M24.4758 33.0234H22.5046L22.5046 33.3463H24.4758L24.4758 33.0234Z'
          fill='#B3DAE3'
        />
        <path
          d='M24.4758 42.9297H22.5046L22.5046 43.2527H24.4758L24.4758 42.9297Z'
          fill='#B3DAE3'
        />
        <path
          d='M27.1426 27.1641H24.4763L24.4763 30.8991H27.1426L27.1426 27.1641Z'
          fill='#F39518'
        />
        <path
          d='M27.1426 40.3672H24.4763L24.4763 41.0002H27.1426L27.1426 40.3672Z'
          fill='#F39518'
        />
        <path
          d='M10.695 31.4688H10.3308L10.3308 33.1865H10.695L10.695 31.4688Z'
          fill='#4883A8'
        />
        <path
          d='M10.695 25.9297H10.3308L10.3308 30.3023H10.695L10.695 25.9297Z'
          fill='#4883A8'
        />
        <path
          d='M10.695 30.3047H10.3308L10.3308 31.4475H10.695L10.695 30.3047Z'
          fill='#193569'
        />
        <path
          d='M10.695 43.3516H10.3308L10.3308 44.2102H10.695L10.695 43.3516Z'
          fill='#4883A8'
        />
        <path
          d='M10.6952 33.1797H10.331L10.331 43.352H10.6952L10.6952 33.1797Z'
          fill='#193569'
        />
        <path
          d='M10.695 44.2188H10.3308L10.3308 45.8341H10.695L10.695 44.2188Z'
          fill='#193569'
        />
        <path
          d='M14.2341 28.8516H13.9226L13.9226 29.7709H14.2341L14.2341 28.8516Z'
          fill='#057080'
        />
        <path
          d='M14.2341 27.1875H13.9226L13.9226 28.851H14.2341L14.2341 27.1875Z'
          fill='#055C69'
        />
        <path
          d='M14.2341 41.9844H13.9226L13.9226 42.9285H14.2341L14.2341 41.9844Z'
          fill='#057080'
        />
        <path
          d='M14.2341 29.7812H13.9226L13.9226 41.9882H14.2341L14.2341 29.7812Z'
          fill='#055C69'
        />
        <path
          d='M14.2341 42.9297H13.9226L13.9226 45.8321H14.2341L14.2341 42.9297Z'
          fill='#055C69'
        />
        <path
          d='M16.3926 43.7891H16.0139L16.0139 44.3889H16.3926L16.3926 43.7891Z'
          fill='#0A4169'
        />
        <path
          d='M16.3926 42.1562H16.0139L16.0139 42.756H16.3926L16.3926 42.1562Z'
          fill='#0A4169'
        />
        <path
          d='M16.3926 30.4062H16.0139L16.0139 35.9466H16.3926L16.3926 30.4062Z'
          fill='#0A4169'
        />
        <path
          d='M16.3926 28.3828H16.0139L16.0139 30.411H16.3926L16.3926 28.3828Z'
          fill='#1E7BA3'
        />
        <path
          d='M16.3927 35.9609H16.0141L16.0141 42.1626H16.3927L16.3927 35.9609Z'
          fill='#1E7BA3'
        />
        <path
          d='M16.3926 42.75H16.0139L16.0139 43.78H16.3926L16.3926 42.75Z'
          fill='#1E7BA3'
        />
        <path
          d='M16.3926 44.3828H16.0139L16.0139 45.8278H16.3926L16.3926 44.3828Z'
          fill='#1E7BA3'
        />
        <path
          d='M20.5333 29.3125H20.2351L20.2351 29.9421H20.5333L20.5333 29.3125Z'
          fill='#BF4A2B'
        />
        <path
          d='M20.5333 27.1875H20.2351L20.2351 29.3107H20.5333L20.5333 27.1875Z'
          fill='#DE9114'
        />
        <path
          d='M20.5333 40.9297H20.2351L20.2351 41.5588H20.5333L20.5333 40.9297Z'
          fill='#BF4A2B'
        />
        <path
          d='M20.5333 29.9453H20.2351L20.2351 40.939H20.5333L20.5333 29.9453Z'
          fill='#DE9114'
        />
        <path
          d='M20.5333 41.5703H20.2351L20.2351 45.8311H20.5333L20.5333 41.5703Z'
          fill='#DE9114'
        />
        <path
          d='M22.505 30.8984H22.0579L22.0579 31.3168H22.505L22.505 30.8984Z'
          fill='#CC4F2E'
        />
        <path
          d='M22.505 29.7812H22.0579L22.0579 30.9077H22.505L22.505 29.7812Z'
          fill='#D66D36'
        />
        <path
          d='M22.505 32.6953H22.0579L22.0579 36.9685H22.505L22.505 32.6953Z'
          fill='#CC4F2E'
        />
        <path
          d='M22.505 31.3203H22.0579L22.0579 32.6907H22.505L22.505 31.3203Z'
          fill='#D66D36'
        />
        <path
          d='M22.505 43.7891H22.0579L22.0579 44.2185H22.505L22.505 43.7891Z'
          fill='#CC4F2E'
        />
        <path
          d='M22.505 42.25H22.0579L22.0579 42.6793H22.505L22.505 42.25Z'
          fill='#CC4F2E'
        />
        <path
          d='M22.505 36.9531H22.0579L22.0579 42.2291H22.505L22.505 36.9531Z'
          fill='#D66D36'
        />
        <path
          d='M22.505 42.6719H22.0579L22.0579 43.7869H22.505L22.505 42.6719Z'
          fill='#D66D36'
        />
        <path
          d='M22.505 44.2188H22.0579L22.0579 45.8341H22.505L22.505 44.2188Z'
          fill='#D66D36'
        />
        <path
          d='M24.4761 31.8828H24.095L24.095 33.0167H24.4761L24.4761 31.8828Z'
          fill='#58A0B3'
        />
        <path
          d='M24.4761 29.7812H24.095L24.095 31.57H24.4761L24.4761 29.7812Z'
          fill='#58A0B3'
        />
        <path
          d='M24.4761 31.5625H24.095L24.095 31.8855H24.4761L24.4761 31.5625Z'
          fill='#99BAC2'
        />
        <path
          d='M24.4761 43.25H24.095L24.095 45.8294H24.4761L24.4761 43.25Z'
          fill='#58A0B3'
        />
        <path
          d='M24.4761 33.3438H24.095L24.095 42.9263H24.4761L24.4761 33.3438Z'
          fill='#58A0B3'
        />
        <path
          d='M24.4761 42.9297H24.095L24.095 43.2527H24.4761L24.4761 42.9297Z'
          fill='#99BAC2'
        />
        <path
          d='M24.4761 33.0234H24.095L24.095 33.3463H24.4761L24.4761 33.0234Z'
          fill='#99BAC2'
        />
        <path
          d='M27.1421 30.8984H26.7283L26.7283 40.3686H27.1421L27.1421 30.8984Z'
          fill='#1F8554'
        />
        <path
          d='M27.1426 25.9297H26.7288L26.7288 27.1471H27.1426L27.1426 25.9297Z'
          fill='#1F8554'
        />
        <path
          d='M27.1421 27.1641H26.7283L26.7283 30.8991H27.1421L27.1421 27.1641Z'
          fill='#DB7100'
        />
        <path
          d='M27.1421 41.0078H26.7283L26.7283 45.8317H27.1421L27.1421 41.0078Z'
          fill='#1F8554'
        />
        <path
          d='M27.1421 40.3672H26.7283L26.7283 41.0002H27.1421L27.1421 40.3672Z'
          fill='#DB7100'
        />
        <path
          d='M29.4882 31.658L30.0567 34.2544L29.6198 34.35L32.0651 45.5178L30.5764 45.8438L27.1428 30.162L28.6315 29.8359L29.0514 31.7537L29.4882 31.658Z'
          fill='#DF5632'
        />
        <path
          d='M29.4903 31.6487L27.5647 32.0703L28.1332 34.6668L30.0588 34.2452L29.4903 31.6487Z'
          fill='#FFBF17'
        />
        <path
          d='M30.0592 34.2793L29.6223 34.375L32.0677 45.5433L32.5046 45.4476L30.0592 34.2793Z'
          fill='#BA482A'
        />
        <path
          d='M29.0709 29.7325L28.634 29.8281L29.054 31.7459L29.4908 31.6503L29.0709 29.7325Z'
          fill='#BA482A'
        />
        <path
          d='M29.4903 31.6544L29.0535 31.75L29.622 34.3465L30.0588 34.2508L29.4903 31.6544Z'
          fill='#FFA217'
        />
      </g>
      <path
        d='M2.99463 37.6719L6.65315 38.042L6.65315 39.7407L2.99463 37.6719Z'
        fill='#DE6B66'
      />
      <path
        d='M2.99463 30.2891L6.65315 30.6592L6.65315 31.9921L2.99463 30.2891Z'
        fill='#DE6B66'
      />
      <path
        d='M11.2779 37.6527C10.3911 38.9466 9.94488 39.1229 8.54997 38.9399C6.6491 38.6905 4.92908 37.8978 1.10823 36.4039C-0.263471 35.8676 0.127305 34.2239 0.66465 32.992L1.28045 31.5813C1.92329 30.1083 2.93819 30.081 3.85575 30.5523C7.65162 32.5021 9.63013 33.4105 11.0669 34.6409C12.2191 35.6277 12.145 36.3875 11.2779 37.6527Z'
        fill='#FFA399'
      />
      <path
        d='M9.78691 44.3838C8.4575 46.7378 6.93685 45.1021 1.54539 42.49C0.191432 41.834 0.404863 40.9678 0.942235 39.7359L1.28026 38.9616C1.9231 37.4886 2.99671 37.3613 3.85556 37.9326C7.26396 40.1999 11.3175 41.6737 9.78691 44.3838Z'
        fill='#FFA399'
      />
      <path
        d='M12.0918 30.3121C10.6382 32.8571 9.03428 32.3647 1.9977 29.1295C0.659516 28.5143 0.701861 27.6708 1.23923 26.439L2.16993 24.3069C2.81277 22.834 3.8556 22.7559 4.74522 23.2779C12.028 27.552 13.801 27.3194 12.0918 30.3121Z'
        fill='#FFA399'
      />
      <path
        d='M8.17376 45.0396C8.14694 45.0396 8.11817 45.0359 8.08804 45.0312C7.62631 44.9595 6.31743 44.5181 5.81271 43.3514C5.78491 43.2873 5.81441 43.2127 5.8786 43.1849C5.94272 43.1571 6.01739 43.1866 6.0451 43.2508C6.52908 44.3695 7.87106 44.7428 8.13748 44.7826C8.40816 44.4574 9.33159 43.2622 9.40658 42.868C9.21095 42.4284 8.35346 41.7619 7.0613 41.667C6.99157 41.6619 6.93917 41.6011 6.94429 41.5314C6.94938 41.4617 7.00942 41.4094 7.07986 41.4144C8.3919 41.5108 9.41942 42.1974 9.65483 42.8055L9.6655 42.833L9.66285 42.8625C9.61525 43.3959 8.30502 44.9771 8.29188 44.9923C8.26018 45.0286 8.21984 45.0396 8.17376 45.0396Z'
        fill='#DE6B66'
      />
      <path
        d='M9.8637 38.5317C9.83859 38.5317 9.81404 38.5279 9.79248 38.5246C9.40967 38.4652 7.87141 37.9924 7.34054 36.7654C7.31274 36.7012 7.34227 36.6267 7.40642 36.5989C7.47069 36.5711 7.54519 36.6006 7.57293 36.6648C8.06072 37.7922 9.53822 38.2243 9.82483 38.2734C10.1121 37.9286 11.1952 36.5456 11.2781 36.14C11.0715 35.7125 9.90331 35.1776 8.58908 35.081C8.51934 35.0759 8.46695 35.0152 8.47207 34.9455C8.47719 34.8757 8.53663 34.8236 8.60763 34.8284C9.99003 34.93 11.2995 35.4901 11.5267 36.0769L11.5374 36.1045L11.5347 36.1339C11.4873 36.6662 9.99269 38.4676 9.97768 38.4848C9.94533 38.522 9.90388 38.5317 9.8637 38.5317Z'
        fill='#DE6B66'
      />
      <path
        d='M10.4844 31.3991C10.4592 31.3991 10.4345 31.3953 10.4129 31.3919C10.0301 31.3324 8.49183 30.8594 7.96113 29.6328C7.93336 29.5686 7.96289 29.4941 8.02704 29.4663C8.09117 29.4385 8.16578 29.4681 8.19349 29.5322C8.67961 30.6556 10.1481 31.0885 10.4423 31.1402C10.6886 30.8108 11.8746 29.1308 11.9605 28.7006C11.7432 28.2339 10.5995 27.658 9.33998 27.5655C9.27024 27.5604 9.21785 27.4997 9.22297 27.4299C9.22806 27.3602 9.28755 27.3072 9.35853 27.3129C10.6627 27.4087 11.968 28.0155 12.2089 28.6379L12.2196 28.6655L12.217 28.6949C12.1698 29.2244 10.6137 31.3346 10.5983 31.3522C10.566 31.3893 10.5246 31.3991 10.4844 31.3991Z'
        fill='#DE6B66'
      />
      <path
        d='M33.5202 35.3125C33.5202 35.3125 32.0376 38.7697 30.9261 42.091C29.8221 45.39 29.8996 48.7951 26.6356 50.8198C22.1855 53.5803 34.1761 55.9775 35.7801 48.0424C37.384 40.1073 33.5202 35.3125 33.5202 35.3125Z'
        fill='#FFA399'
      />
      <path
        d='M33.5195 28.0335C33.3524 25.7515 32.669 24.6211 33.2718 22.4754C33.8746 20.3297 33.9851 20.3377 34.7867 19.3192C35.5883 18.3008 33.6866 30.3156 33.5195 28.0335Z'
        fill='#FFA399'
      />
    </svg>
  );
};

export default ForColleges;
